import ZTable, { ITableRef } from '@/components/ZTable';
import MainContent from '@/layouts/MainContent';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Tooltip, Button } from 'antd';
import { FilePdfFilled, PrinterFilled, InfoCircleOutlined } from '@ant-design/icons';
import { TicketIcon } from '@/assets/icons/entities/_';
import TicketsModal from './modals/tickets.modal';
import { exportService } from '@/services/exportService';
import { PAGE_TITLE, columns, filters } from '.';
import bixolonWebPrintService from '@/services/bixolonWebPrintService';
import { PrinterType } from '@/constants';
import BookingChangeModal from './modals/bookingChange.modal';
import { sumBy } from 'lodash';
import { BookingPagingDto } from '@/__generated';
import { apiSdk } from '@/httpClient';

const width = sumBy(columns, x => x.width || 0);
export default function BookingPage() {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [displayTicketsModal, setDisplayTicketsModal] = React.useState<BookingPagingDto>();
  const [bookingChangeId, setBookingChangeId] = React.useState<string>();

  const downloadPdf = (bookingId: string) => {
    exportService.downloadBookingPdf(bookingId);
  };
  const printTicket = (booking: BookingPagingDto) => {
    apiSdk.StationPrinterService.getStationPrintersByRegister({ registerId: booking.registerId || '' }).then(printers => {
      apiSdk.BookingDetailService.getBookingDetailsForPrinting({ id: booking.bookingId || '' }).then(res => {
        const printer = bixolonWebPrintService.getAvailablePrinter(PrinterType.Tags, printers);
        bixolonWebPrintService.printLabelTicket(printer, res);
      });
    });
  };
  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <ZTable<BookingPagingDto>
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          scroll={{ x: width }}
          url="/bookings/booking-details/get-booking-paging"
          bordered
          order_by="createdOn"
          order_by_asc={false}
          allowEdit={false}
          allowDelete={false}
          filters={filters}
          searchBtnAlignLeft
          actionColumnWidth={150}
          rowClassName={row => (row.onlineBookingId ? 'highlight-row' : '')}
          extraActions={[
            {
              render: record => {
                return (
                  <Tooltip title={t('bookingPage_ViewTickets')}>
                    <Button
                      size="small"
                      onClick={() => {
                        setDisplayTicketsModal(record);
                      }}
                      type="link"
                      icon={<TicketIcon style={{ height: 14 }} />}
                    />
                  </Tooltip>
                );
              },
            },
            {
              render: record => {
                return (
                  <Tooltip title={t('bookingPage_DownloadPdf')}>
                    <Button
                      size="small"
                      onClick={() => {
                        downloadPdf(record.bookingId || '');
                      }}
                      type="link"
                      danger
                      icon={<FilePdfFilled />}
                    />
                  </Tooltip>
                );
              },
            },
            {
              render: record => {
                return (
                  <Tooltip title={t('bookingPage_PrintTicket')}>
                    <Button
                      size="small"
                      onClick={() => {
                        printTicket(record);
                      }}
                      type="link"
                      icon={<PrinterFilled />}
                    />
                  </Tooltip>
                );
              },
            },
            {
              render: record => {
                return (
                  <Tooltip title={t('bookingPage_BookingHistory')}>
                    <Button
                      size="small"
                      onClick={() => {
                        setBookingChangeId(record.bookingId);
                      }}
                      type="link"
                      danger
                      icon={<InfoCircleOutlined />}
                    />
                  </Tooltip>
                );
              },
            },
          ]}
        />
      </div>
      {displayTicketsModal ? <TicketsModal booking={displayTicketsModal} onClose={() => setDisplayTicketsModal(undefined)} /> : null}
      {bookingChangeId ? <BookingChangeModal bookingId={bookingChangeId} onClose={() => setBookingChangeId(undefined)} /> : null}
    </MainContent>
  );
}
